export default __webpack_public_path__ + "static/media/Ballroll_00301.047671a9.png";